import gsap from "gsap";
import { Map as ElMap } from "maplibre-gl";

type Tween = {
	value: number;
	goalValue: number;
}

const targets = new Map<string, Tween>()

export function tweenOpacity(id: string, value: number, source: string, useFeatureState: boolean, map: ElMap) {
	// mapid ise used in key to get new values when switching to satellite
	const ident = `${id}-${source}-${map._getMapId()}`
	let isNew = false
	if (!targets.has(ident)) {
		targets.set(ident, { value, goalValue: value })
		isNew = true
	}

	const target = targets.get(ident)
	if (target) {
		// it's slightly faster to bail early here I THINK.
		if (target.goalValue == value && !isNew) {
			return
		}
		target.goalValue = value
		gsap.killTweensOf(target)
		gsap.to(target, {
			duration: useFeatureState ? .4 : (value ? .3 : .1),
			value,
			onUpdate: () => {
				try {
					if (!map.style || !map.isStyleLoaded()) return
					if (useFeatureState) {
						map.setFeatureState(
							{ id, source },
							{ opacity: target.value }
						)
					}
				} catch {
					gsap.killTweensOf(target)
				}
			}
		})
	}


}